<template>
  <NotFound v-if="typeCheck === 'error'" />
  <main class="main-content-area" v-else>
    <!-- Game banner section -->
    <section
      class="ct-inner-banner pt-26"
      v-if="feature_image"
      :style="{ background: $root.color_schema.primary }"
    >
      <div class="container">
        <!--Breadcrumps-->
        <div class="col-md-12" v-if="breadcrumb && breadcrumb.length > 0">
          <Breadcrumb
            :breadcrumbData="breadcrumb"
            :dark="getContrastYIQ($root.color_schema.primary)"
          />
        </div>
        <!--End Breadcrumps-->
        <div class="row">
          <div class="col-md-12">
            <NotSupportModal
              v-if="$root.disableNotSupportBanner"
              :notsupportbannerData="$root.notsupportbannerData"
            />
            <div
              class="
                casino-card
                casino-card-software
                casino-card-bonus
                casino-card-payment-toplist
              "
              :style="{
                height:
                  !$root.disable_not_supported_banner &&
                  $root.disableNotSupportBanner &&
                  softwareWidth < 576
                    ? '565px'
                    : null,
              }"
            >
              <div class="bonus-card-logo">
                <img
                  v-if="$root.enable_lazyload && feature_image"
                  v-lazy="feature_image"
                  width="400"
                  height="400"
                  :alt="getAltText(page_title, feature_image)"
                />
                <img
                  v-else-if="feature_image"
                  :src="feature_image"
                  width="400"
                  height="400"
                  :alt="getAltText(page_title, feature_image)"
                />
              </div>
              <div class="bonus-card-content">
                <div
                  class="bonus-card-content-top"
                  v-if="
                    (softwareProcons && softwareProconsArr.length > 0) ||
                    (top_section &&
                      top_section.procons &&
                      top_section.procons.length > 0)
                  "
                >
                  <template v-if="feature_pro_name && feature_pro_name != ''">
                    <span class="span-h6 custom-font-1"
                      >{{ $root.i18n.why_use }} {{ feature_pro_name }}?</span
                    >
                  </template>
                  <div :class="{ 'why-use': true, expanded: showMorePros }">
                    <template
                      v-if="softwareProcons && softwareProconsArr.length > 0"
                    >
                      <ul class="proslist-soft">
                        <li
                          v-for="data in softwareProconsArr
                            .filter((ele) => ele.is_featured === '1')
                            .sort(
                              (ele1, ele2) =>
                                ele2.is_positive - ele1.is_positive
                            )
                            .slice(0, 4)"
                          :key="data.id"
                          :class="{
                            'pros-green':
                              data.is_featured === '1' &&
                              data.is_positive === '1',
                            'pros-red':
                              data.is_featured === '1' &&
                              data.is_positive === '0',
                          }"
                        >
                          {{ data.description }}
                        </li>
                      </ul>
                    </template>
                    <template v-else>
                      <ul
                        class="proslist-soft"
                        v-if="
                          top_section &&
                          top_section.procons &&
                          top_section.procons.length > 0
                        "
                      >
                        <li
                          v-for="data in top_section.procons
                            .filter((ele) => ele.is_positive === '1')
                            .slice(0, 4)"
                          :key="data.id"
                          class="pros-green"
                        >
                          {{ data.description }}
                        </li>
                      </ul>
                    </template>
                    <template v-if="softwareProcons">
                      <template v-if="softwareProconsArr.length > 1">
                        <a
                          :title="$root.i18n.show_more_pros"
                          @click="showMorePros = true"
                          v-if="!showMorePros"
                          class="show-more"
                          ><i></i>{{ $root.i18n.show_more_pros }}</a
                        >
                        <a
                          :title="$root.i18n.show_less_pros"
                          @click="showMorePros = false"
                          v-if="showMorePros"
                          class="show-less"
                          ><i></i>{{ $root.i18n.show_less_pros }}</a
                        >
                      </template>
                    </template>
                    <template
                      v-else-if="
                        top_section &&
                        top_section.procons &&
                        top_section.procons.length > 1
                      "
                    >
                      <a
                        :title="$root.i18n.show_more_pros"
                        @click="showMorePros = true"
                        v-if="!showMorePros"
                        class="show-more"
                        ><i></i>{{ $root.i18n.show_more_pros }}</a
                      >
                      <a
                        :title="$root.i18n.show_less_pros"
                        @click="showMorePros = false"
                        v-if="showMorePros"
                        class="show-less"
                        ><i></i>{{ $root.i18n.show_less_pros }}</a
                      >
                    </template>
                  </div>
                </div>
                <div
                  :class="{
                    'bonus-card-content-bottom pb-0': true,
                    'rm-top-padding': !(
                      (softwareProcons && softwareProconsArr.length > 0) ||
                      (top_section &&
                        top_section.procons &&
                        top_section.procons.length > 0)
                    ),
                  }"
                >
                  <template v-if="hideToplistLabel"> </template>
                  <template v-else>
                    <template v-if="top_section && top_section.product_id">
                      <div
                        class="best-choice-casino-icon"
                        v-if="top_section && top_section.go_link"
                      >
                        <a
                          :title="top_section.product_name"
                          :href="
                            getGoLink(top_section.go_link, top_section.slug)
                          "
                          class="partner-logo cas-link"
                          :rel="
                            $root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow'
                          "
                          target="_blank"
                        >
                          <img
                            v-if="
                              $root.enable_lazyload &&
                              assets_images &&
                              assets_images.pro_asset_sizes
                            "
                            v-lazy="
                              top_section.product_assets.filter(
                                (ele) =>
                                  ele.asset_category_name ===
                                  assets_images.pro_asset_sizes.medium
                              ).length > 0
                                ? top_section.product_assets
                                    .filter(
                                      (ele) =>
                                        ele.asset_category_name ===
                                        assets_images.pro_asset_sizes.medium
                                    )
                                    .shift().url
                                : ''
                            "
                            width="90"
                            height="90"
                            :alt="
                              getAltText(
                                top_section.product_name,
                                top_section.product_assets.filter(
                                  (ele) =>
                                    ele.asset_category_name ===
                                    assets_images.pro_asset_sizes.medium
                                ).length > 0
                                  ? top_section.product_assets
                                      .filter(
                                        (ele) =>
                                          ele.asset_category_name ===
                                          assets_images.pro_asset_sizes.medium
                                      )
                                      .shift().url
                                  : ''
                              )
                            "
                          />
                          <img
                            v-else-if="
                              assets_images && assets_images.pro_asset_sizes
                            "
                            :src="
                              top_section.product_assets.filter(
                                (ele) =>
                                  ele.asset_category_name ===
                                  assets_images.pro_asset_sizes.medium
                              ).length > 0
                                ? top_section.product_assets
                                    .filter(
                                      (ele) =>
                                        ele.asset_category_name ===
                                        assets_images.pro_asset_sizes.medium
                                    )
                                    .shift().url
                                : $root.site_url +
                                  $root.asset_path +
                                  '/failure.png'
                            "
                            width="90"
                            height="90"
                            :alt="
                              getAltText(
                                top_section.product_name,
                                top_section.product_assets.filter(
                                  (ele) =>
                                    ele.asset_category_name ===
                                    assets_images.pro_asset_sizes.medium
                                ).length > 0
                                  ? top_section.product_assets
                                      .filter(
                                        (ele) =>
                                          ele.asset_category_name ===
                                          assets_images.pro_asset_sizes.medium
                                      )
                                      .shift().url
                                  : $root.site_url +
                                      $root.asset_path +
                                      '/failure.png'
                              )
                            "
                          />
                          <div class="partner-hover wd-soft-bann">
                            <div
                              class="partner-hover-inner"
                              :style="{
                                '--primary-btn': $root.color_schema.primary_btn,
                                '--primary-btn-hover': pSBC(
                                  -0.2,
                                  $root.color_schema.primary_btn
                                ),
                              }"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="10"
                                height="16"
                                viewBox="0 0 10 16"
                                fill="none"
                              >
                                <path
                                  d="M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z"
                                  fill="white"
                                />
                              </svg>
                            </div>
                          </div>
                          <div
                            :class="{
                              stripe: true,
                              'font-dark': getContrastYIQ(
                                Object.keys(hasTag(top_section.tags)).length > 0
                                  ? hasTag(top_section.tags).color
                                  : null
                              ),
                              'font-light': !getContrastYIQ(
                                Object.keys(hasTag(top_section.tags)).length > 0
                                  ? hasTag(top_section.tags).color
                                  : null
                              ),
                            }"
                            v-if="
                              Object.keys(hasTag(top_section.tags)).length > 0
                            "
                            :style="{
                              backgroundColor:
                                Object.keys(hasTag(top_section.tags)).length > 0
                                  ? hasTag(top_section.tags).color
                                  : null,
                            }"
                          >
                            <img
                              :src="hasTag(top_section.tags).icon"
                              width="18"
                              height="12"
                              alt="tag-icons"
                            />
                          </div>
                          <i class="best-reward">
                            <img
                              :src="
                                $root.site_url +
                                $root.asset_path +
                                '/svg-icons/cup-icon.svg'
                              "
                              width="20"
                              height="29"
                              alt="Cup Icon"
                            />
                          </i>
                        </a>
                      </div>
                      <div class="best-choice-casino-cont">
                        <div class="best-choice">
                          <i>
                            <img
                              :src="
                                $root.site_url +
                                $root.asset_path +
                                '/svg-icons/cup-icon.svg'
                              "
                              width="20"
                              height="29"
                              alt="Cup Icon"
                            />
                          </i>
                          <template v-if="top_section.go_link">
                            <a
                              :title="top_section.product_name"
                              :href="
                                getGoLink(top_section.go_link, top_section.slug)
                              "
                              class="best-choice-cont cas-link"
                              target="_blank"
                              :rel="
                                $root.change_cta_to_sponsored
                                  ? 'nofollow sponsored'
                                  : 'nofollow'
                              "
                            >
                              <span
                                class="
                                  span-h6 span-fix
                                  color-orange
                                  custom-font-1
                                "
                                >{{ $root.i18n.best_choice_casino }}</span
                              >
                              <span class="span-fix"
                                >{{ $root.i18n.play_at }}
                                {{ top_section.product_name }}</span
                              >
                            </a>
                          </template>
                          <div class="best-rating" v-if="top_section.rating">
                            <StarRating
                              :rating="
                                parseFloat((top_section.rating / 2).toFixed(1))
                              "
                            />
                          </div>
                        </div>
                        <div
                          class="best-choice-casino-cont-title"
                          :style="{
                            '--hover-color': $root.color_schema.primary_btn,
                          }"
                        >
                          <template v-if="hideBonusLabel">
                            <span>{{ $root.i18n.hidden_partner_bonus }}</span>
                          </template>
                          <template v-else>
                            <span
                              class="span-h2 text-hover custom-font-1"
                              v-if="
                                top_section.bonus_match &&
                                top_section.exclusive_bonus_amount &&
                                top_section.exclusive_bonus_match
                              "
                            >
                              <a
                                :title="top_section.product_name"
                                :href="
                                  getGoLink(
                                    top_section.go_link,
                                    top_section.slug
                                  )
                                "
                                class="cas-link"
                                target="_blank"
                                :rel="
                                  $root.change_cta_to_sponsored
                                    ? 'nofollow sponsored'
                                    : 'nofollow'
                                "
                                >{{ top_section.exclusive_bonus_match }}%
                                {{ $root.i18n.up_to }}
                                {{
                                  top_section.exclusive_bonus_amount
                                    | currency(top_section.bonus_currency)
                                }}
                                <template
                                  v-if="
                                    top_section.freespin ||
                                    top_section.freebie_name
                                  "
                                >
                                  <template
                                    v-if="
                                      (top_section.exclusive_bonus_amount ||
                                        top_section.bonus_amount) &&
                                      top_section.bonus_match
                                    "
                                    >+</template
                                  >
                                  <template v-if="top_section.freespin">
                                    <template
                                      v-if="
                                        pageData.show_freebie_currency === '1'
                                      "
                                      >{{
                                        top_section.freespin
                                          | currency(top_section.bonus_currency)
                                      }}</template
                                    >
                                    <template v-else>{{
                                      top_section.freespin
                                    }}</template>
                                    {{ top_section.freebie_name }}
                                  </template>
                                  <template v-else>{{
                                    top_section.freebie_name
                                  }}</template>
                                </template>
                              </a>
                            </span>
                            <span
                              class="span-h2 custom-font-1"
                              v-if="
                                top_section.bonus_match &&
                                !top_section.exclusive_bonus_amount &&
                                top_section.bonus_amount
                              "
                            >
                              <a
                                :title="top_section.product_name"
                                :href="
                                  getGoLink(
                                    top_section.go_link,
                                    top_section.slug
                                  )
                                "
                                class="cas-link"
                                target="_blank"
                                :rel="
                                  $root.change_cta_to_sponsored
                                    ? 'nofollow sponsored'
                                    : 'nofollow'
                                "
                                >{{ top_section.bonus_match }}%
                                {{ $root.i18n.up_to }}
                                {{
                                  top_section.bonus_amount
                                    | currency(top_section.bonus_currency)
                                }}
                                <template
                                  v-if="
                                    top_section.freespin ||
                                    top_section.freebie_name
                                  "
                                >
                                  <template
                                    v-if="
                                      (top_section.exclusive_bonus_amount ||
                                        top_section.bonus_amount) &&
                                      top_section.bonus_match
                                    "
                                    >+</template
                                  >
                                  <template v-if="top_section.freespin">
                                    <template
                                      v-if="
                                        pageData.show_freebie_currency === '1'
                                      "
                                      >{{
                                        top_section.freespin
                                          | currency(top_section.bonus_currency)
                                      }}</template
                                    >
                                    <template v-else>{{
                                      top_section.freespin
                                    }}</template>
                                    {{ top_section.freebie_name }}
                                  </template>
                                  <template v-else>{{
                                    top_section.freebie_name
                                  }}</template>
                                </template>
                              </a>
                            </span>
                            <span
                              class="span-h2 custom-font-1 text-hover"
                              v-else-if="
                                (top_section.bonus_match ||
                                  top_section.exclusive_bonus_amount) &&
                                !top_section.exclusive_bonus_match
                              "
                            >
                              <template
                                v-if="
                                  top_section.freespin ||
                                  top_section.freebie_name
                                "
                              >
                                <a
                                  :title="top_section.product_name"
                                  :href="
                                    getGoLink(
                                      top_section.go_link,
                                      top_section.slug
                                    )
                                  "
                                  class="cas-link"
                                  target="_blank"
                                  :rel="
                                    $root.change_cta_to_sponsored
                                      ? 'nofollow sponsored'
                                      : 'nofollow'
                                  "
                                >
                                  <template v-if="top_section.freespin">
                                    <template
                                      v-if="
                                        pageData.show_freebie_currency === '1'
                                      "
                                      >{{
                                        top_section.freespin
                                          | currency(top_section.bonus_currency)
                                      }}</template
                                    >
                                    <template v-else>{{
                                      top_section.freespin
                                    }}</template>
                                    {{ top_section.freebie_name }}
                                  </template>
                                  <template v-else>{{
                                    top_section.freebie_name
                                  }}</template>
                                </a>
                              </template>
                            </span>
                          </template>
                          <div class="btn-block">
                            <template v-if="top_section.go_link">
                              <a
                                :title="top_section.product_name"
                                :href="
                                  getGoLink(
                                    top_section.go_link,
                                    top_section.slug
                                  )
                                "
                                :class="{
                                  'cta cta-primary cta-promotion cas-link custom-btn hover-btn': true,
                                  'text-white':
                                    !$root.override_ctabtntxt_color &&
                                    !getContrastYIQ(
                                      $root.color_schema.primary_btn
                                    ),
                                  'text-gray':
                                    !$root.override_ctabtntxt_color &&
                                    getContrastYIQ(
                                      $root.color_schema.primary_btn
                                    ),
                                  'text-cta-override':
                                    $root.override_ctabtntxt_color,
                                }"
                                target="_blank"
                                :rel="
                                  $root.change_cta_to_sponsored
                                    ? 'nofollow sponsored'
                                    : 'nofollow'
                                "
                                :style="{
                                  '--primary-btn':
                                    $root.color_schema.primary_btn,
                                  '--primary-btn-hover': pSBC(
                                    -0.2,
                                    $root.color_schema.primary_btn
                                  ),
                                }"
                                ><span class="cta-text">{{
                                  top_section.cta_button_text
                                }}</span
                                ><span
                                  class="hover-text"
                                  v-for="(char, indexGo) in $root.i18n
                                    .go_to_casino"
                                  :key="indexGo + `softpp`"
                                  >{{ char }}</span
                                >
                                <!--<span
                          class="hover-text"
                          v-for="(char,
                          indexPro) in top_section.product_name.split('')"
                          :key="indexPro + `soft`"
                          >{{ char }}</span
                        >--></a
                              >
                            </template>
                            <template v-if="$root.enable_piwik_reload">
                              <a
                                :title="top_section.product_name"
                                v-if="top_section.review_link"
                                :href="
                                  getRouteLink(
                                    top_section.review_link,
                                    'review'
                                  )
                                "
                                class="read-review"
                                >{{
                                  getPartnerGlobalString(
                                    $root.i18n.read_our_review,
                                    top_section.product_name
                                  )
                                }}</a
                              >
                            </template>
                            <template v-else>
                              <router-link
                                :title="top_section.product_name"
                                v-if="top_section.review_link"
                                :to="
                                  getRouteLink(
                                    top_section.review_link,
                                    'review'
                                  )
                                "
                                class="read-review"
                                >{{
                                  getPartnerGlobalString(
                                    $root.i18n.read_our_review,
                                    top_section.product_name
                                  )
                                }}</router-link
                              >
                            </template>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <template v-if="noPartnerAvailableOption">
                        <span>{{ noPartnerAvailableText }}</span>
                      </template>
                    </template>
                  </template>
                </div>
                <!--For mobile-->
                <template v-if="top_section && top_section.product_id">
                  <div class="best-choice-casino-cont-title view-mob pb-10">
                    <template v-if="hideBonusLabel"
                      ><span>{{ $root.i18n.hidden_partner_bonus }}</span>
                    </template>
                    <template v-else>
                      <span
                        class="span-h2 text-hover custom-font-1"
                        v-if="
                          top_section.bonus_match &&
                          top_section.exclusive_bonus_amount &&
                          top_section.exclusive_bonus_match
                        "
                      >
                        <a
                          :title="top_section.product_name"
                          :href="
                            getGoLink(top_section.go_link, top_section.slug)
                          "
                          class="cas-link"
                          target="_blank"
                          :rel="
                            $root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow'
                          "
                          >{{ top_section.exclusive_bonus_match }}%
                          {{ $root.i18n.up_to }}
                          {{
                            top_section.exclusive_bonus_amount
                              | currency(top_section.bonus_currency)
                          }}
                          <template
                            v-if="
                              top_section.freespin || top_section.freebie_name
                            "
                          >
                            <template
                              v-if="
                                (top_section.exclusive_bonus_amount ||
                                  top_section.bonus_amount) &&
                                top_section.bonus_match
                              "
                              >+</template
                            >
                            <template v-if="top_section.freespin">
                              <template
                                v-if="pageData.show_freebie_currency === '1'"
                                >{{
                                  top_section.freespin
                                    | currency(top_section.bonus_currency)
                                }}</template
                              >
                              <template v-else>{{
                                top_section.freespin
                              }}</template>
                              {{ top_section.freebie_name }}
                            </template>
                            <template v-else>{{
                              top_section.freebie_name
                            }}</template>
                          </template>
                        </a>
                      </span>
                      <span
                        class="span-h2 custom-font-1"
                        v-if="
                          top_section.bonus_match &&
                          !top_section.exclusive_bonus_amount &&
                          top_section.bonus_amount
                        "
                      >
                        <a
                          :title="top_section.product_name"
                          :href="
                            getGoLink(top_section.go_link, top_section.slug)
                          "
                          class="cas-link"
                          target="_blank"
                          :rel="
                            $root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow'
                          "
                          >{{ top_section.bonus_match }}%
                          {{ $root.i18n.up_to }}
                          {{
                            top_section.bonus_amount
                              | currency(top_section.bonus_currency)
                          }}
                          <template
                            v-if="
                              top_section.freespin || top_section.freebie_name
                            "
                          >
                            <template
                              v-if="
                                (top_section.exclusive_bonus_amount ||
                                  top_section.bonus_amount) &&
                                top_section.bonus_match
                              "
                              >+</template
                            >
                            <template v-if="top_section.freespin">
                              <template
                                v-if="pageData.show_freebie_currency === '1'"
                                >{{
                                  top_section.freespin
                                    | currency(top_section.bonus_currency)
                                }}</template
                              >
                              <template v-else>{{
                                top_section.freespin
                              }}</template>
                              {{ top_section.freebie_name }}
                            </template>
                            <template v-else>{{
                              top_section.freebie_name
                            }}</template>
                          </template>
                        </a>
                      </span>
                      <span
                        class="span-h2 custom-font-1 text-hover"
                        v-else-if="
                          (top_section.bonus_match ||
                            top_section.exclusive_bonus_amount) &&
                          !top_section.exclusive_bonus_match
                        "
                      >
                        <template
                          v-if="
                            top_section.freespin || top_section.freebie_name
                          "
                        >
                          <a
                            :title="top_section.product_name"
                            :href="
                              getGoLink(top_section.go_link, top_section.slug)
                            "
                            class="cas-link"
                            target="_blank"
                            :rel="
                              $root.change_cta_to_sponsored
                                ? 'nofollow sponsored'
                                : 'nofollow'
                            "
                          >
                            <template v-if="top_section.freespin">
                              <template
                                v-if="pageData.show_freebie_currency === '1'"
                                >{{
                                  top_section.freespin
                                    | currency(top_section.bonus_currency)
                                }}</template
                              >
                              <template v-else>{{
                                top_section.freespin
                              }}</template>
                              {{ top_section.freebie_name }}
                            </template>
                            <template v-else>{{
                              top_section.freebie_name
                            }}</template>
                          </a>
                        </template>
                      </span>
                    </template>
                    <div class="btn-block">
                      <template v-if="top_section.go_link">
                        <a
                          :title="top_section.product_name"
                          :href="
                            getGoLink(top_section.go_link, top_section.slug)
                          "
                          :class="{
                            'cta cta-primary cta-promotion cas-link custom-btn hover-btn': true,
                            'text-white':
                              !$root.override_ctabtntxt_color &&
                              !getContrastYIQ($root.color_schema.primary_btn),
                            'text-gray':
                              !$root.override_ctabtntxt_color &&
                              getContrastYIQ($root.color_schema.primary_btn),
                            'text-cta-override': $root.override_ctabtntxt_color,
                          }"
                          target="_blank"
                          :rel="
                            $root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow'
                          "
                          :style="{
                            '--primary-btn': $root.color_schema.primary_btn,
                            '--primary-btn-hover': pSBC(
                              -0.2,
                              $root.color_schema.primary_btn
                            ),
                          }"
                          ><span class="cta-text">{{
                            top_section.cta_button_text
                          }}</span
                          ><span
                            class="hover-text"
                            v-for="(char, indexGo) in $root.i18n.go_to_casino"
                            :key="indexGo + `softpp`"
                            >{{ char }}</span
                          ></a
                        >
                      </template>
                      <template v-if="$root.enable_piwik_reload">
                        <a
                          :title="top_section.product_name"
                          v-if="top_section.review_link"
                          :href="
                            getRouteLink(top_section.review_link, 'review')
                          "
                          class="read-review"
                          >{{
                            getPartnerGlobalString(
                              $root.i18n.read_our_review,
                              top_section.product_name
                            )
                          }}</a
                        >
                      </template>
                      <template v-else>
                        <router-link
                          :title="top_section.product_name"
                          v-if="top_section.review_link"
                          :to="getRouteLink(top_section.review_link, 'review')"
                          class="read-review"
                          >{{
                            getPartnerGlobalString(
                              $root.i18n.read_our_review,
                              top_section.product_name
                            )
                          }}</router-link
                        >
                      </template>
                    </div>
                  </div>
                </template>
                <!--End For mobile-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <template v-else>
      <template
        v-if="
          !$root.disable_not_supported_banner && $root.disableNotSupportBanner
        "
      >
        <section
          class="ct-inner-banner pt-26"
          :style="{ background: $root.color_schema.primary }"
        >
          <div class="container">
            <!--Breadcrumps-->
            <div class="col-md-12" v-if="breadcrumb && breadcrumb.length > 0">
              <Breadcrumb
                :breadcrumbData="breadcrumb"
                :dark="getContrastYIQ($root.color_schema.primary)"
              />
            </div>
            <!--End Breadcrumps-->
            <div class="row">
              <div class="col-md-12">
                <NotSupportModal
                  v-if="$root.disableNotSupportBanner"
                  :notsupportbannerData="$root.notsupportbannerData"
                />
                <div
                  class="
                    casino-card
                    casino-card-software
                    casino-card-bonus
                    casino-card-payment-toplist
                  "
                  :style="{
                    height:
                      !$root.disable_not_supported_banner &&
                      $root.disableNotSupportBanner &&
                      softwareWidth < 576
                        ? '565px'
                        : null,
                  }"
                ></div>
              </div>
            </div>
          </div>
        </section>
      </template>
    </template>
    <!-- End Game banner section -->
    <div
      :class="{ 'custom-background-image': $root.color_schema.site_bg_img }"
      :style="{
        '--bg-image': `url(${$root.color_schema.site_bg_img}) repeat`,
        '--bg-color': $root.color_schema.site_bg_color,
      }"
    >
      <a
        class="main-tag cas-link"
        :href="getGoLink($root.goto_link, $root.slug)"
        v-if="$root.color_schema.site_bg_img"
        target="_blank"
        :rel="$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'"
      ></a>
      <div
        :class="{
          'custom-background-color': $root.color_schema.site_bg_img,
          'pb-25': blockData.length > 0,
          'pt-26':
            !feature_image &&
            !(
              !$root.disable_not_supported_banner &&
              $root.disableNotSupportBanner
            ),
        }"
        v-observer:subtree="mutationObserve"
      >
        <section
          v-if="
            !feature_image &&
            !(
              !$root.disable_not_supported_banner &&
              $root.disableNotSupportBanner
            )
          "
        >
          <div class="container overflow-auto">
            <!--Breadcrumps-->
            <div class="col-md-12" v-if="breadcrumb && breadcrumb.length > 0">
              <Breadcrumb :breadcrumbData="breadcrumb" :dark="true" />
            </div>
            <!--End Breadcrumps-->
          </div>
        </section>

        <!-- Horizontal Cards -->
        <section
          v-if="blockData.length > 0"
          :class="{
            'ct-card-horizontal-game':
              feature_image ||
              (!$root.disable_not_supported_banner &&
                $root.disableNotSupportBanner),
          }"
        >
          <template v-for="(data, index) in blockData">
            <CustomComponent :key="`${data.blockName}-${index}`" 
              :blockData="data" 
              :recommendSection="data.blockName === 'wpvcb/casino-toplist' && !data.attrs.style ? recommend_section : {}"
              :bluebar="data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? bluebar : {}"
              :blockIndex="index"
              />
          </template>
        </section>
        <!-- Horizontal Cards ends -->

        <section
          class="ct-editor-section"
          v-if="
            endOfblockData &&
            advantage.title &&
            advantage.options &&
            disadvantage.title &&
            disadvantage.options
          "
        >
          <div class="container">
            <!--Pros and Cons-->
            <div class="casino-card casino-card-pros-cons desk-view">
              <div class="half-col">
                <h2 class="custom-font-1">{{ advantage.title }}</h2>
                <ul class="proslist">
                  <li
                    class="pros"
                    v-for="(pros, index) in advantage.options"
                    :key="index"
                  >
                    {{ pros.option }}
                  </li>
                </ul>
              </div>
              <div class="divider"></div>
              <div class="half-col">
                <h2 class="custom-font-1">{{ disadvantage.title }}</h2>
                <ul class="proslist">
                  <li
                    class="cons"
                    v-for="(cons, index) in disadvantage.options"
                    :key="index"
                  >
                    {{ cons.option }}
                  </li>
                </ul>
              </div>
            </div>
            <!--For mobile-->
            <div
              class="pros-cons-tab"
              v-if="
                advantage.title &&
                advantage.options &&
                disadvantage.title &&
                disadvantage.options
              "
            >
              <ul class="tab-items">
                <template v-if="advantage.title && disadvantage.title">
                  <li @click="showProConsTab" :class="{ active: showPros }">
                    <i>
                      <img
                        :src="
                          $root.site_url +
                          $root.asset_path +
                          '/svg-icons/polygon-green.svg'
                        "
                        alt="Green Polygon"
                      />
                    </i>
                    <span>{{ advantage.title.split(" ").shift() }}</span>
                  </li>
                  <li @click="showProConsTab" :class="{ active: !showPros }">
                    <i>
                      <img
                        :src="
                          $root.site_url +
                          $root.asset_path +
                          '/svg-icons/polygon-orange.svg'
                        "
                        alt="Orange Polygon"
                      />
                    </i>
                    <span>{{ disadvantage.title.split(" ").shift() }}</span>
                  </li>
                </template>
              </ul>
              <div
                class="casino-card casino-card-pros-cons pros-cons-tab-content"
              >
                <div :class="{ 'item-content': true, active: showPros }">
                  <h3 class="custom-font-1">{{ advantage.title }}</h3>
                  <ul class="proslist">
                    <li
                      class="pros"
                      v-for="(cons, index) in disadvantage.options"
                      :key="index"
                    >
                      {{ cons.option }}
                    </li>
                  </ul>
                </div>
                <div :class="{ 'item-content': true, active: !showPros }">
                  <h3 class="custom-font-1">{{ disadvantage.title }}</h3>
                  <ul class="proslist">
                    <li
                      class="cons"
                      v-for="(cons, index) in disadvantage.options"
                      :key="index"
                    >
                      {{ cons.option }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <!--End For mobile-->
            <!--End Pros and Cons-->
          </div>
        </section>

        <!--Related Page Links-->
        <template v-if="endOfblockData && morePaymentBottom">
          <RelatedLinks :relatedLinkData="morePaymentBottom" />
        </template>
        <!--End Related Page Links-->

        <!--Author Block-->
        <template v-if="auhtorBlockdata && endOfblockData"> </template>
        <!--End Author Block-->
      </div>
    </div>
  </main>
</template>

<script>
import StarRating from "@/components/ui/StarRating";
import CustomComponent from '@/components/CustomComponent'
import Breadcrumb from "@/components/layouts/Breadcrumb";
import RelatedLinks from "@/components/custom-block/RelatedLinks";
import NotSupportModal from "@/components/custom-block/NotSupportModal";
import NotFound from "@/pages/404";
import currency from "@/misc/currency";
import { pSBC, getContrastYIQ, getOffset } from "@/misc/misc-function";
import { metaChanger } from "@/misc/meta-changer";
import { HttpService } from "@/api/Pages.api";

export default {
  name: "SoftwareProviders",
  props: ["softwareProviderData"],
  components: {
    StarRating,
    Breadcrumb,
    CustomComponent,
    RelatedLinks,
    NotSupportModal,
    NotFound,
  },
  data: function () {
    return {
      diposit: true,
      showMorePros: false,
      withdraw: true,
      showPros: true,
      pageData: {
        type: Array,
        default: () => [],
      },
      top_block: {
        type: Object,
        default: () => {},
      },
      feature_image: "",
      feature_pro_name: "",
      page_title: "",
      top_casino_title: {
        type: String,
        default: () => "",
      },
      diposit_withdraw: {
        type: Array,
        default: () => [],
      },
      diposit_only: {
        type: Array,
        default: () => [],
      },
      withdraw_only: {
        type: Array,
        default: () => [],
      },
      top_section: {
        type: Object,
        default: () => {},
      },
      advantage: {
        title: "",
        options: {
          type: Array,
          default: () => [],
        },
      },
      disadvantage: {
        title: {
          type: String,
          default: () => "",
        },
        options: {
          type: Array,
          default: () => [],
        },
      },
      morePaymentBottom: {
        type: Object,
        default: () => {},
      },
      breadcrumb: {
        type: Array,
        default: () => [],
      },
      top_block: {
        type: Object,
        default: () => {},
      },
      assets_images: {
        type: Object,
        default: () => {},
      },
      embedBlockNameList: [
        "core-embed/facebook",
        "core-embed/twitter",
        "core-embed/instagram",
        "core-embed/tumblr",
        "core-embed/tiktok",
      ],
      blockData: [],
      blockDataIndex: 0,
      busy: false,
      endOfblockData: false,
      hideBonusLabel: false,
      hideToplistLabel: false,
      scriptFlag: 0,
      softwareProcons: false,
      softwareProconsArr: [],
      auhtorBlockdata: [],
      rightBlockdata: [],
      noPartnerAvailableOption: false,
      noPartnerAvailableText: "",
      softwareWidth: 0,
      typeCheck: "",
      bluebar: {},
    };
  },
  methods: {
    pSBC,
    getContrastYIQ,
    metaChanger,
    getOffset,
    showProConsTab: function () {
      this.showPros = !this.showPros;
    },
    getPageData: function () {
      HttpService.getBody(
        this.$root.wp_country && this.$root.wp_country != ""
          ? this.$root.wp_country
          : this.$cookies.get("wp-country"),
        this.$root.wp_state && this.$root.wp_state != ""
          ? this.$root.wp_state
          : this.$cookies.get("wp-state"),
        this.$route.params.postSlug,
        this.$root.user_id
      )
        .then(
          (res) => {
            const res_data = res.data.data;
            this.pageData = res_data.content.blocks;
            const top_casino = res_data.top_casino;
            this.top_casino_title = top_casino ? top_casino.group_title : "";
            this.page_title = res_data.title;
            this.feature_pro_name =
              res_data.topsection_sofft_info &&
              res_data.topsection_sofft_info.length > 0
                ? res_data.topsection_sofft_info[0].sw_name
                : "";
            this.feature_image =
              res_data.topsection_sofft_info &&
              res_data.topsection_sofft_info.length > 0
                ? res_data.topsection_sofft_info.shift().swa_url
                : "";
            this.top_section = res_data.topsection
              ? res_data.topsection.shift()
              : "";

            this.noPartnerAvailableOption = res_data.hasOwnProperty(
              "no_partner_available_option"
            )
              ? res_data.no_partner_available_option
              : false;

            if (this.noPartnerAvailableOption)
              this.noPartnerAvailableText = res_data.hasOwnProperty(
                "no_partner_available_text"
              )
                ? res_data.no_partner_available_text
                : "";

            //software procons
            this.softwareProcons = res_data.software_procons;
            if (this.softwareProcons) {
              this.softwareProconsArr = res_data.hasOwnProperty("procons")
                ? res_data.procons
                : [];
            }

            // Assets Sizes
            this.assets_images =
              Object.keys(this.$root.asset_sizes).length > 0
                ? this.$root.asset_sizes
                : "";

            // Pros Cons Section
            this.advantage.title = res_data.meta.advantage_title;
            this.advantage.options = res_data.meta.advantage_options;
            this.disadvantage.title = res_data.meta.disadvantage_title;
            this.disadvantage.options = res_data.meta.disadvantage_options;

            // More Payments Bottom Card
            this.morePaymentBottom = res_data.meta.more_payment_method;

            // Author Blocks Filtered
            let atBlock = res_data.content.blocks.filter((ele) => {
              if (ele.blockName === "wpvcb/author-block") {
                return ele.filtered_content;
              }
            });
            if (atBlock.length > 0)
              this.auhtorBlockdata = atBlock.shift().filtered_content;

            // RightContent Blocks Filtered
            let rightBlock = res_data.content.blocks.filter((ele) => {
              if (ele.blockName === "wpvcb/right-content-simpletoc") {
                return ele.filtered_content;
              }
            });
            if (rightBlock.length > 0)
              this.rightBlockdata = rightBlock.shift().filtered_content;

            // Breadcrumb
            this.breadcrumb = res_data.breadcrumb;

            // Adminbar Data
            this.$root.adminBarData =
              Object.keys(res_data.toolbar).length > 0 ? res_data.toolbar : "";
            this.$root.disable = this.$root.adminBarData
              ? this.$root.adminBarData.visible
              : false;

            //NotSupportBanner
            this.$root.notsupportbannerData =
              res_data.not_supported_banner &&
              Object.keys(res_data.not_supported_banner).length > 0
                ? res_data.not_supported_banner
                : "";
            this.$root.disableNotSupportBanner =
              this.top_section && Object.keys(this.top_section).length > 0
                ? false
                : true;

            this.$root.noScroll =
              this.top_section && Object.keys(this.top_section).length > 0
                ? false
                : true;
            this.$root.notsupportassetSizes =
              Object.keys(this.$root.asset_sizes).length > 0
                ? this.$root.asset_sizes
                : "";
            this.$root.notSupportPageType = "software";
            this.$root.notSupportType = res_data.type;

            // Schema Append
            document.getElementById("schema-script").innerHTML =
              res_data.schema;

            this.getBonusShowHide(this.top_section);
          },
          (err) => console.log(err),
          () => {
            // if (!this.$root.enable_lazyload) {
            this.blockData = this.pageData;
            this.blockDataIndex = this.pageData.length;
            this.$root.show_footer = true;
            this.$root.body_loading_status = true;
            // } else {
            // if (this.pageData.length > 0) {
            //   if (!this.top_section) {
            //     this.blockData.push(this.pageData[this.blockDataIndex]);
            //     this.blockDataIndex++;
            //   }
            //   this.$root.show_footer = false;
            // } else {
            //   this.$root.show_footer = true;
            // }
            //}
          }
        )
        .catch((err) => {
          this.typeCheck = "error";
          this.$root.loading = false;
        });
    },
    heightCheck: function () {
      let appDOM = document.getElementById("app");
      let windowHeight = window.innerHeight;
      let appBottom = appDOM.scrollHeight - windowHeight - window.pageYOffset;
      if (appBottom < windowHeight / 2) {
        this.loadMore();
      }
    },
    // Infinite scroll Height Checking
    mutationObserve: function (mutations) {
      if (this.blockData.length < this.pageData.length) {
        let mainContentArea =
          this.getOffset(mutations[0].target).top +
          mutations[0].target.offsetHeight;
        if (mainContentArea < window.innerHeight) {
          this.incrementBlockDataValue();
          this.heightCheck();
        }
      }
    },
    // Infinite scroll load more
    loadMore: function () {
      if (this.blockData.length < this.pageData.length) {
        this.busy = true;
        this.incrementBlockDataValue();
        //this.heightCheck();
        this.busy = false;
      } else {
        this.endOfblockData = true;
      }
    },
    incrementBlockDataValue: function () {
      this.blockData = this.pageData.slice(0, this.blockDataIndex + 1);
      this.blockDataIndex++;
    },
    itemFAQ: function (data) {
      let FAQitems = [];
      data.forEach((ele) => {
        let { id, faq_question: title, faq_answer: content } = ele;

        let is_active = false;
        if (ele.is_active === "1") {
          is_active = true;
        }

        FAQitems.push({ id, title, content, is_active });
      });
      return FAQitems;
    },
    getBonusShowHide: function (partner) {
      let hideBonus = this.getCASToplistShowHideData(partner);
      if (hideBonus.hide_bonus === "1") {
        this.hideBonusLabel = true;
      } else if (hideBonus.hide_toplist === "1") {
        this.hideToplistLabel = true;
      }
    },
  },
  created: function () {
    if (
      this.$root.routes_meta[this.$route.params.postSlug] &&
      this.$root.routes_meta[this.$route.params.postSlug].metaTags
    )
      this.metaChanger(
        this.$root.routes_meta[this.$route.params.postSlug].metaTags
      );
  },
  mounted: function () {
    if (this.softwareProviderData != undefined) {
      const res_data = this.softwareProviderData;
      this.pageData = res_data.content.blocks;
      const top_casino = res_data.top_casino;
      this.top_casino_title = top_casino ? top_casino.group_title : "";
      this.page_title = res_data.title;
      this.feature_pro_name =
        res_data.topsection_sofft_info &&
        res_data.topsection_sofft_info.length > 0
          ? res_data.topsection_sofft_info[0].sw_name
          : "";
      this.feature_image =
        res_data.topsection_sofft_info &&
        res_data.topsection_sofft_info.length > 0
          ? res_data.topsection_sofft_info.shift().swa_url
          : "";

      this.top_section = res_data.topsection ? res_data.topsection.shift() : "";

      this.noPartnerAvailableOption = res_data.hasOwnProperty(
        "no_partner_available_option"
      )
        ? res_data.no_partner_available_option
        : false;

      if (this.noPartnerAvailableOption)
        this.noPartnerAvailableText = res_data.hasOwnProperty(
          "no_partner_available_text"
        )
          ? res_data.no_partner_available_text
          : "";

      //software procons
      this.softwareProcons = res_data.software_procons;
      if (this.softwareProcons) {
        this.softwareProconsArr = res_data.hasOwnProperty("procons")
          ? res_data.procons
          : [];
      }

      // Assets Sizes
      this.assets_images =
        Object.keys(this.$root.asset_sizes).length > 0
          ? this.$root.asset_sizes
          : "";

      // Pros Cons Section
      this.advantage.title = res_data.meta.advantage_title;
      this.advantage.options = res_data.meta.advantage_options;
      this.disadvantage.title = res_data.meta.disadvantage_title;
      this.disadvantage.options = res_data.meta.disadvantage_options;

      // More Payments Bottom Card
      this.morePaymentBottom = res_data.meta.more_payment_method;

      // Author Blocks Filtered
      let atBlock = res_data.content.blocks.filter((ele) => {
        if (ele.blockName === "wpvcb/author-block") {
          return ele.filtered_content;
        }
      });
      if (atBlock.length > 0)
        this.auhtorBlockdata = atBlock.shift().filtered_content;

      // RightContent Blocks Filtered
      let rightBlock = res_data.content.blocks.filter((ele) => {
        if (ele.blockName === "wpvcb/right-content-simpletoc") {
          return ele.filtered_content;
        }
      });
      if (rightBlock.length > 0)
        this.rightBlockdata = rightBlock.shift().filtered_content;

      // Breadcrumb
      this.breadcrumb = res_data.breadcrumb;

      // Adminbar Data
      this.$root.adminBarData =
        Object.keys(res_data.toolbar).length > 0 ? res_data.toolbar : "";
      this.$root.disable = this.$root.adminBarData
        ? this.$root.adminBarData.visible
        : false;

      //NotSupportBanner
      this.$root.notsupportbannerData =
        res_data.not_supported_banner &&
        Object.keys(res_data.not_supported_banner).length > 0
          ? res_data.not_supported_banner
          : "";
      this.$root.disableNotSupportBanner =
        this.top_section && Object.keys(this.top_section).length > 0
          ? false
          : true;

      this.$root.noScroll =
        this.top_section && Object.keys(this.top_section).length > 0
          ? false
          : true;
      this.$root.notsupportassetSizes =
        Object.keys(this.$root.asset_sizes).length > 0
          ? this.$root.asset_sizes
          : "";
      this.$root.notSupportPageType = "software";
      this.$root.notSupportType = res_data.type;

      // if (!this.$root.enable_lazyload) {
      this.blockData = this.pageData;
      this.blockDataIndex = this.pageData.length;
      this.$root.show_footer = true;
      // } else {
      // if (this.pageData.length > 0) {
      //   if (!this.top_section) {
      //     this.incrementBlockDataValue();
      //   }
      //   this.$root.show_footer = false;
      // } else {
      //   this.$root.show_footer = true;
      // }
      //}

      // Schema Append
      document.getElementById("schema-script").innerHTML = res_data.schema;

      this.getBonusShowHide(this.top_section);
    } else {
      this.$root.loading = true;
      this.getPageData();
    }
    if (
      this.scriptFlag === 0 &&
      this.pageData.filter((ele) => {
        return (
          ele.blockName === "wpvcb/custom-youtube" ||
          ele.blockName === "wpvcb/youtube-film-strip"
        );
      }).length > 0
    ) {
      this.youtubeInit();
      this.scriptFlag++;
    }
    this.$nextTick(() => {
      this.heightCheck();
      this.softwareWidth = window.innerWidth;
    });
    var that = this;
    window.addEventListener(
      "scroll",
      () => {
        that.heightCheck();
      },
      { passive: true }
    );
    window.addEventListener("resize", () => {
      that.heightCheck();
      that.softwareWidth = window.innerWidth;
    });
  },
  beforeDestroy: function () {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    window.removeEventListener(
      "scroll",
      () => {
        that.heightCheck();
      },
      { passive: true }
    );
    window.removeEventListener("resize", () => {
      that.heightCheck();
    });
  },
  filters: {
    currency,
  },
  watch: {
    "$route.params.postSlug": function () {
      if (this.softwareProviderData != undefined) {
      } else {
        this.$root.loading = true;
        this.getPageData();
      }
    },
    blockData: function () {
      if (this.blockData.length === this.pageData.length) {
        this.$root.show_footer = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/base/variable";

.ct {
  &-inner-banner {
    padding: 0px 0 45px;
    background: #070438 url(~@/assets/images/top-bg.svg) no-repeat 0 0;
    .game-space {
      position: relative;
      min-height: 321px;
      @media (min-width: @sizes[extra-small]) {
        min-height: auto;
      }
      img {
        border-radius: 10px;
        box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);
        height: 100%;
        object-fit: cover;
        width: auto;
        max-height: 321px;
        min-height: 321px;
        @media (min-width: @sizes[extra-small]) {
          width: 100%;
          max-height: none;
          min-height: auto;
        }
      }
      &-content {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        padding: 20px;
        .display-flex();
        .align-items(center);
        .justify-content-center();
        .flex-direction-column();
        .button-block {
          .display-flex();
          .align-items(center);
          .justify-content-center();
          .flex-direction-column();
          width: 100%;
          margin-bottom: 15px;
          .cta {
            min-width: 100%;
            margin: 5px 0;
            font-weight: bold;
            font-size: 14px;
            line-height: 17px;
            padding: 10px 18px;
            @media (min-width: @sizes[medium]) {
              min-width: 330px;
              margin: 10px 0;
              padding: 15px 18px;
              font-size: 18px;
              line-height: 22px;
            }
          }
        }
        .game-logo {
          img {
            box-shadow: none;
            max-height: none;
            min-height: auto;
          }
        }
      }
    }
    .row {
      .col-md-8 {
        @media (min-width: @sizes[medium]) {
          width: 100%;
          float: none;
        }
        @media (min-width: @sizes[large]) {
          width: 66.66666667%;
          float: left;
        }
      }
      .col-md-4 {
        @media (min-width: @sizes[medium]) {
          width: 100%;
          float: none;
        }
        @media (min-width: @sizes[large]) {
          width: 33.33333333%;
          float: left;
        }
      }
    }
    &-lft {
      margin-bottom: 19px;
      @media (min-width: @sizes[large]) {
        margin-bottom: 0;
      }
      @media (min-width: @sizes[extraX-large]) {
        width: 906px !important;
      }
    }
    &-rgt {
      @media (min-width: @sizes[extraX-large]) {
        width: 314px !important;
      }
    }
  }
}

.review-tab {
  &-menu {
    ul {
      .display-flex();
      .align-items(center);
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
      border-bottom: 1px solid @border-gray;
      max-width: 960px;
      li {
        margin-right: 30px;
        display: inline-block;
        padding: 10px 0px;
        font-weight: 400;
        font-size: 16px;
        color: @mid-gray;
        line-height: 25px;
        cursor: pointer;
        position: relative;
        &:after {
          position: absolute;
          content: "";
          left: 0;
          bottom: -5px;
          width: 100%;
          height: 3px;
          background: @orange;
          .transition(all 0.3s);
        }
        &:hover,
        &.active {
          color: @orange;
          &:after {
            bottom: 0;
          }
        }
        &.active {
          font-weight: 700;
        }
      }
    }
    &-toplist {
      ul {
        border-bottom: 0;
        margin-bottom: 0;
        li {
          &:before,
          &:after {
            display: none;
          }
          font-size: 12px;
          line-height: 15px;
          color: @lightdark;
          background: @gray-dim;
          box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);
          .border-radius(12px);
          text-align: center;
          min-width: 130px;
          padding: 10px 5px;
          margin-right: 10px;
          &:hover,
          &.active {
            background: @yellow;
            color: @lightdark;
            font-weight: 400;
          }
        }
      }
    }
  }
  &-container {
    margin: 0;
    .tab-content {
      display: none;
      padding-top: 30px;
      padding-bottom: 30px;
      &.active {
        display: block;
      }
    }
    &-toplist {
      .tab-content {
        padding-top: 15px;
        .casino-card-horizontal {
          &:first-child {
            margin-top: 0;
          }
        }
      }
    }
  }
}

.ct {
  &-card-promotion {
    padding: 24px 0 17px 0;
    background-color: @darkblue;
    background-image: url("~@/assets/images/svg-icons/Patetrn.svg");
    background-repeat: no-repeat;
    background-position: right bottom;
    background-size: 60%;
    @media (min-width: @sizes[medium]) {
      padding: 48px 0 20px 0;
    }
    h2 {
      color: @white;
    }
    .promotion-card {
      background: @white;
      box-shadow: none;
      .border-radius(0);
      .display-flex();
      .align-items(center);
      padding: 5px 9px 11px;
      border-bottom: 1px solid @light-gray;
      @media (min-width: @sizes[large]) {
        display: block;
        box-shadow: 0 1px 8px rgba(0, 0, 0, 0.2);
        padding: 0;
        .border-radius(12px);
        border-bottom: 0;
      }
      &-img {
        .border-radius(12px);
        background: @light-gray;
        width: 62px;
        height: 62px;
        .display-flex();
        .align-items(center);
        .justify-content-center();
        padding: 5px 12px;
        position: relative;
        @media (min-width: @sizes[large]) {
          background: linear-gradient(129.32deg, #f6f5f5 6.36%, #f6f5f5 71.95%);
          .border-radius(12px 12px 0px 0px);
          height: 200px;
          width: 100%;
          padding: 0;
          display: block;
        }
        img {
          min-width: auto;
          height: auto;
          margin-bottom: 0;
          @media (min-width: @sizes[large]) {
            min-width: 114px;
          }
        }
      }
      &-content {
        padding: 0 12px;
        @media (min-width: @sizes[large]) {
          padding: 20px;
        }
        .promotion-title {
          a {
            font-size: 16px;
            font-weight: 700;
            @media (min-width: @sizes[large]) {
              font-weight: 400;
            }
          }
        }
        p {
          display: none;
          @media (min-width: @sizes[large]) {
            color: @dark-gray;
            margin: 10px 0;
            display: block;
          }
        }
        h5 {
          margin-bottom: 0;
          @media (min-width: @sizes[large]) {
            display: none;
          }
        }
        .cta-gray {
          display: none;
          @media (min-width: @sizes[large]) {
            display: block;
          }
        }
      }
    }

    &-toplist {
      background-image: none;
      background-color: transparent;
      padding: 10px 0 45px;
      margin-right: -20px;
      @media (min-width: @sizes[medium]) {
        margin-right: -15px;
      }
      @media (min-width: @sizes[large]) {
        margin-right: 0;
      }
      .promotion-card {
        box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);
        .border-radius(12px);
        display: block;
        padding: 0;
        min-width: 250px;
        @media (min-width: @sizes[large]) {
          min-width: auto;
        }
      }
      .promotion-card-img {
        .border-radius(12px 12px 0px 0px;);
        background: @lighter-gray;
        height: 154px;
        width: 100%;
        img {
          width: auto;
          max-width: 115px;
          margin: 0;
          @media (min-width: @sizes[medium]) {
            width: auto;
            max-width: none;
          }
        }
      }
      .promotion-card-content {
        padding: 25px 15px;
        text-align: center;
        white-space: normal;
        @media (min-width: @sizes[sm-large]) {
          padding: 25px 20px;
        }
        h6 {
          margin-bottom: 10px;
          a {
            color: @lightdark;
          }
        }
        p {
          text-align: center;
          color: @lightdark;
          display: block;
        }
        .cta {
          padding: 15px 10px;
          font-size: 16px;
          display: block;
          @media (min-width: @sizes[sm-large]) {
            font-size: 18px;
          }
          @media (min-width: @sizes[md-large]) {
            padding: 15px;
          }
        }
      }
    }
  }
  &-card-promotion__m {
    .row {
      margin: 0;
      @media (min-width: @sizes[large]) {
        margin: 0 -8px;
      }
    }
    .row [class^="col-"] {
      padding: 0;
      @media (min-width: @sizes[large]) {
        padding: 0 8px;
      }
    }
  }
}

.promotion-inner {
  position: static;
  width: auto;
  text-align: center;
  @media (min-width: @sizes[large]) {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
  }
  p {
    white-space: nowrap;
    font-weight: 700;
    margin-bottom: 0;
    margin-top: 25px;
    display: none;
    @media (min-width: @sizes[large]) {
      display: inline-block;
    }
  }
  &-img {
    min-height: auto;
    .display-flex();
    .align-items(center);
    .justify-content-center();
    @media (min-width: @sizes[large]) {
      min-height: 92px;
    }
  }
}
.ct {
  &-selection-casino {
    .selection-cont {
      max-width: 960px;
      h2 {
        color: @mob-black;
        margin-bottom: 16px;
        @media (min-width: @sizes[medium]) {
          margin-bottom: 16px;
          color: @lightdark;
        }
      }
    }
  }
  &-related-page-links {
    background: @lightdark;
    .border-radius(0);
    padding: 18px 20px;
    margin: 0;
    display: block;
    @media (min-width: @sizes[medium]) {
      .display-flex();
      .flex-direction-row();
      .align-items(center);
      .border-radius(12px);
      margin: 35px 0 25px;
    }
    h6 {
      font-weight: bold;
      color: @white;
      margin-bottom: 12px;
      white-space: nowrap;
      @media (min-width: @sizes[medium]) {
        margin-bottom: 0;
        margin-right: 27px;
      }
    }
    ul {
      overflow-x: auto;
      white-space: nowrap;
      li {
        margin-right: 40px;
        display: inline-block;
        &:last-child {
          margin-right: 0;
        }
        a {
          font-size: 16px;
          line-height: 160%;
          color: @white;
          font-family: var(--default-regular);
        }
      }
    }
  }

  &-similar-casino-cards {
    padding-bottom: 30px;
    .container {
      padding-right: 0;
      @media (min-width: @sizes[tablet]) {
        padding: 0 15px;
      }
    }
    .mobile-scroller {
      &::-webkit-scrollbar-track {
        background-color: @white;
      }
      .row [class^="col-"] {
        padding: 0 8px;
        @media (min-width: @sizes[large]) {
          padding: 0 4px;
        }
        @media (min-width: @sizes[md-large]) {
          padding: 0 8px;
        }
      }
      .casino-card-similar {
        padding: 15px;
        white-space: normal;
        min-width: 254px;
        @media (min-width: @sizes[large]) {
          padding: 10px;
          min-width: auto;
        }
        @media (min-width: @sizes[md-large]) {
          padding: 15px;
        }
      }
    }
  }
  &-review-toplist-page {
    padding-top: 30px;
  }
}

.pb-25 {
  padding-bottom: 25px;
}

.show_btn {
  margin-top: 0px !important;
}

.pros-cons-tab {
  .flex-direction-column();
  display: block;
  margin-top: 30px;
  @media (min-width: @sizes[medium]) {
    display: none;
  }
  .pros-cons-tab-content {
    margin: 0;
    padding: 60px 25px 30px;
    .item-content {
      display: none;
      &.active {
        display: block;
      }
    }
  }
  ul {
    &.tab-items {
      list-style-type: none;
      .display-flex();
      margin: 0 0 -26px 0;
      li {
        &:before {
          display: none;
        }
        background: @gray-dim;
        box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);
        .border-radius(12px);
        .display-flex();
        .align-items(center);
        .justify-content-center();
        padding-left: 0;
        width: 59px;
        height: 52px;
        line-height: 1;
        margin: 0 12px 0 0;
        cursor: pointer;
        i {
          img {
            margin: 0;
          }
        }
        span {
          padding-left: 10px;
          font-weight: bold;
          font-size: 16px;
          line-height: 20px;
          color: @lightdark;
          display: none;
        }
        &.active {
          background: @white;
          width: 153px;
          span {
            display: block;
          }
        }
      }
    }
  }
}

.pros-cons-tab-content {
  .item-content {
    h3 {
      color: @lightdark;
    }
  }
}

.page-links-outr {
  .container {
    padding: 0;
    @media (min-width: 768px) {
      padding: 0 15px;
    }
  }
  .ct {
    &-related-page-links {
      @media (max-width: @sizes[small]) {
        background-color: @dark-blue2;
      }
      .router-link-exact-active {
        color: @white;
      }
    }
  }
}

.best-choice-casino-icon img {
  border-radius: 12px;
}

.alter-pt12 {
  padding-bottom: 12px !important;
}

.pt-37 {
  padding-top: 37px;
}

.hide-mob {
  display: none;
  @media (min-width: @sizes[medium]) {
    display: block;
  }
}

.casino-header {
  display: table;
  width: 100%;
  background: @darkblue;
  .border-radius(12px);
  h2 {
    text-align: center;
    color: @white;
    font-weight: bold;
    padding: 8px;
  }
}

.ct-card-horizontal {
  padding: 45px 0;
  background-color: @light-gray;
  &-game {
    padding: 32px 0;
    .casino-card-horizontal:first-child {
      margin-top: 20px;
    }
  }
}

.bonus-card-logo {
  padding: 0 !important;
  background: @white !important;
  img {
    height: 100% !important;
    width: auto;
    object-fit: cover;
    @media (min-width: @sizes[medium]) {
      height: 100% !important;
    }
  }
}

.best-choice-casino-cont-title {
  h2 a {
    &:hover {
      color: var(--hover-color);
    }
  }
  .span-h2 {
    margin: 0 0 6px !important;
    a {
      &:hover {
        color: var(--hover-color);
      }
    }
  }
}

.best-choice-casino-cont {
  padding-left: 15px !important;
}

.best-choice {
  display: flex;
  align-items: start !important;
  flex-direction: column;
  @media (min-width: @sizes[large]) {
    flex-direction: row;
    align-items: flex-end !important;
  }
}

.best-choice-cont {
  padding-left: 0 !important;
  @media (min-width: @sizes[large]) {
    padding-left: 10px !important;
  }
}

.best-rating {
  padding-left: 0px;
  @media (min-width: @sizes[large]) {
    padding-left: 16px;
  }
}

.btn-block {
  .custom-btn {
    margin-top: 0px !important;
  }
  .read-review {
    text-decoration: underline;
  }
}

.pt-30 {
  padding-top: 30px !important;
}

.pt-20 {
  padding-top: 20px !important;
}

.pb-0 {
  padding-bottom: 15px !important;
  @media (min-width: @sizes[medium]) {
    padding-bottom: 16px !important;
  }
  @media (min-width: @sizes[large]) {
    padding-bottom: 30px !important;
  }
}

.pb-10 {
  padding-bottom: 10px !important;
}

.span-fix {
  font-size: 16px;
  line-height: 18px;
  display: block;
  margin-bottom: 0;
}

.bonus-card-content {
  display: flex;
  flex-direction: column;
}
.bonus-card-content-bottom {
  margin-top: auto;
}

.bonus-card-content-top {
  .span-h6 {
    font-size: 16px;
  }
}

.half-col {
  .proslist {
    li {
      width: 100% !important;
    }
  }
}

.stripe {
  //display: block !important;
  text-align: center;
  p {
    font-weight: 700;
  }
}

.stripe {
  position: absolute;
  width: 100%;
  height: 20px;
  bottom: 0;
  top: 50%;
  transform: translateY(27px);
  left: 0;
  overflow: hidden;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  background-color: @yellow;
  display: none;
  @media (min-width: @sizes[small]) {
    display: block;
  }
  img {
    width: 14px !important;
    height: 14px !important;
    border-radius: 0 !important;
    object-fit: contain !important;
  }
  svg,
  img {
    display: block;
    margin: 3px auto;
    width: 15px;
  }
}

.proslist-soft {
  margin: 0;
  padding: 0;
  list-style: none;
  column-count: 0;
  display: block;
  column-count: unset;
  height: 26px;
  overflow: hidden;
  .transition(all 0.3s);
  column-count: unset;
  @media (min-width: @sizes[small]) {
    .flex-wrap(wrap);
    .display-flex();
  }
  @media (min-width: @sizes[large]) {
    column-count: 2;
    height: auto;
    overflow: visible;
  }
  @media (max-width: @sizes[small]) {
    padding-bottom: 6px;
  }
  li {
    position: relative;
    width: 100%;
    text-align: left;
    padding-left: 32px;
    line-height: 25px;
    color: @lightdark;
    margin-bottom: 18px;
    background-size: 15px 15px;
    &:last-child {
      margin-bottom: 0px;
    }
    margin-bottom: 22px;
    width: 100%;
    @media (min-width: @sizes[large]) {
      margin-right: 10px;
      width: calc(50% - 10px);
    }
    &.pros-green {
      &:before {
        position: absolute;
        content: "";
        left: 0;
        top: 0;
        display: inline-block;
        transform: translateY(0px);
        height: 26px;
        width: 26px;
        background: rgba(90, 188, 94, 1) url("~@/assets/images/tick.svg")
          no-repeat;
        border-radius: 100%;
        background-position: center;
        background-size: 14px;
      }
    }
    &.pros-red {
      &:before {
        position: absolute;
        content: "";
        left: 0;
        top: 0;
        display: inline-block;
        transform: translateY(0px);
        height: 26px;
        width: 26px;
        background: rgba(254, 70, 70, 1) url("~@/assets/images/cross.svg")
          no-repeat;
        border-radius: 100%;
        background-position: center;
        background-size: 14px;
      }
    }
  }
}
.why-use {
  &.expanded {
    ul {
      &.proslist-soft {
        height: auto;
        padding-bottom: 10px;
      }
    }
  }
}

.rm-top-padding {
  border-top: none;
}

.casino-card-software {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/SoftwareProviders/SoftwareProviders.vue